import { render, staticRenderFns } from "./CguField.vue?vue&type=template&id=3b9fbe8e&"
import script from "./CguField.vue?vue&type=script&lang=js&"
export * from "./CguField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports